import { React } from 'react';
import screenshot from '../../../images/arcus.png'; // Import the static image

const Screenshots = ({imageUrl}) => {
    return (
        <div className="row screenshot-container">
            <div className="col-lg-10 mx-auto">
                <div className="screenshots mt-5">
                    <div className="img-container">
                        <img src={imageUrl} className="img-fluid w-100" alt="Screenshot" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Screenshots
